import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { first } from 'rxjs/operators';

import { ControlCommunicationService } from '@app/form-builder/services/control-communication.service';

import { SubstancesService, AlertService, RequestsService, NcsService, FilesService } from '@app/core/services';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'substances-review',
    templateUrl: 'modal-substance-review.component.html',
    styleUrls: ['../../../app.component.scss']
})
export class ModalSubstancesReview implements OnInit, OnDestroy {
    @Input() recordId
    @Input() inspectionId
    @Input() version

    versionForm

    code = '';

    loading = true
    save = false
    saving = false
    saved = false

    formInspection
    currentForm = null
    requirements = null
    lastSubmission = null
    requiredForm = null

    files = []
    percentage = 0

    closeModal = false
    saveOnly = false
    saveAll = false
    saveSubstance = false
    saveSubstanceOnly = false
    substanceIndex = 0

    private subscriptions: Subscription

    constructor(
        public modal: NgbActiveModal,
        private substanceService: SubstancesService,
        private alertService: AlertService,
        private requestsService: RequestsService,
        private ncsService: NcsService,
        private formCommunication: ControlCommunicationService,
        private fileService: FilesService,
    ) {
        this.subscriptions = this.formCommunication.changeEmmited$.subscribe(
            async msg => {
                if (msg.identifier === 'send-form' && this.saving) {
                    //console.log(msg.form)
                    const formGroup = msg.form as FormGroup
    
                    if(this.saveOnly) {
                        if (formGroup.valid) {
                            // await this.requestsService.changeFilesIntoUrls(formGroup, this.versionForm, this.recordId)
                            await this.fileService.changeFilesIntoUrls(formGroup, this.versionForm, this.recordId)

                            this.substanceService.saveOnlyFormSubstances(this.recordId, formGroup.value, this.versionForm)
                                .subscribe(data => {
                                    this.saved = true
                                    this.files = []
                                    this.save = true
        
                                    this.percentage = 0
                                    this.saveAll = false
                                    this.saving = false
                                    this.saveSubstance = false
                                    this.saveOnly = false
        
                                    if(this.closeModal) {
                                        this.closeModal = false
                                        
                                        modal.close()
                                    }
                                    else {
                                        this.closeModal = false
        
                                        this.getSubstances()
                                    }
                                }, error => {
                                    this.closeModal = false
                                    this.saveAll = false
                                    this.saving = false
                                    this.saveSubstance = false
                                    this.saveOnly = false
        
                                    this.alertService.error(error, {
                                        autoClose: true
                                    })
                                }
                            )
                        } else {
                            this.closeModal = false
                            this.saveAll = false
                            this.saving = false
                            this.saveSubstance = false
                            this.substanceIndex = 0
                            this.saveOnly = false
    
                            this.alertService.warn('Asegurate de haber completado todos los campos necesarios', {
                                autoClose: true
                            })
                        }
                    } else {
                        for(var i in formGroup.value["lista_sustancias"]){
                            var element = formGroup.value["lista_sustancias"][i]
                            if(this.saveSubstance && parseInt(i) === this.substanceIndex) {
                                if(element.verificacion_lpo === false && element.verificacion_no_permitido === false && (element.verificacion_opr === false || element.verificacion_cor === false) && element.verificacion_ue === false && element.verificacion_nop === false) {
                                    formGroup.disable()
                                }
    
                                this.saveSubstance = false
                            } else if(this.saveAll) {
                                if(element.verificacion_lpo === false && element.verificacion_no_permitido === false && (element.verificacion_opr === false || element.verificacion_cor === false) && element.verificacion_ue === false && element.verificacion_nop === false) {
                                    formGroup.disable()
                                }
                            }
                        }
    
                        if(this.saveSubstanceOnly) {
                            if(formGroup.valid) {
                                this.save = true
                                
                                // await this.requestsService.changeFilesIntoUrls(formGroup, this.versionForm, this.recordId)
                                await this.fileService.changeFilesIntoUrls(formGroup, this.versionForm, this.recordId)

                                this.substanceService.saveOnlyOneSubstances(this.recordId, formGroup.value, this.substanceIndex, this.versionForm)
                                    .subscribe(response => {
                                        var data = formGroup.value
        
                                        setTimeout(() => {
                                            this.formCommunication.emitEvent({
                                                identifier: 'set-values',
                                                form: data
                                            })
                                        }, 100);
            
                                        let body = {
                                            submission: []
                                        }
                                
                                        for (var i in Object.keys(data)) {
                                            const key = Object.keys(data)[i]
                                            body.submission.push({
                                                name: key,
                                                value: data[key]
                                            })
                                        }
        
                                        this.reloadFormData(body)
                                    }, error => {
                                        this.saving = false
                                        this.alertService.error(error, {
                                            autoClose: true
                                        })
                                    }
                                )
    
                                this.closeModal = false
                                this.saveAll = false
                                this.saving = false
                                this.saveSubstance = false
                                this.substanceIndex = 0
                                
                            } else {
                                if(this.saveAll) {
                                    this.alertService.warn('Asegurate de haber completado todos los campos necesarios (Verificación de cada sustancia)', {
                                        autoClose: true
                                    })
                                }
                                else {
                                    this.alertService.warn('Asegurate de haber completado todos los campos necesarios (Verificación de sustancia)', {
                                        autoClose: true
                                    })
                                }
    
                                this.closeModal = false
                                this.saveAll = false
                                this.saving = false
                                this.saveSubstance = false
                                this.substanceIndex = 0
    
                                formGroup.enable()
                            }
                        } else {
                            if (formGroup.valid) {
                                // await this.requestsService.changeFilesIntoUrls(formGroup, this.versionForm, this.recordId)
                                await this.fileService.changeFilesIntoUrls(formGroup, this.versionForm, this.recordId)
                                
                                this.substanceService.saveFormSubstances(this.recordId, formGroup.value, this.versionForm)
                                    .subscribe(
                                        async data => {
                                            this.percentage = 0
                                            this.saved = true
                                            this.saving = false
                                            this.files = []
                                            this.save = true
                                            
                                            this.getSubstances()
            
                                            if(this.closeModal) {
                                                const substances = formGroup.value['lista_sustancias']
                                                for(let i in substances) {
                                                    const item = substances[i]

                                                    if(!item.isValidated) {
                                                        const substance = {
                                                            'nombre_comercial': item.nombre_comercial,
                                                            'ingredientes_activos': item.ingredientes_activos,
                                                            'ingredientes_inertes': item.ingredientes_inertes,
                                                            'nombre_proveedor': item.nombre_proveedor,
                                                            'uso_abono_fungicida_etc': item.uso_abono_fungicida_etc,
                                                            'cultivo_area_aplicacion': item.cultivo_area_aplicacion,
                                                            'ficha_tecnica_anexos_urls': item.ficha_tecnica_anexos_urls,
                                                            'restricciones' : item.restricciones,
                                                            'evaluacion_por_otra_agencia': item.evaluacion_por_otra_agencia,
                                                            'listado_omri_canada': item?.listado_omri_canada ?? '',
                                                            'listado_omri_nop': item?.listado_omri_nop ?? '',
                                                            'listado_otro': item?.listado_otro ?? '',
                                                            'listado_otro_texto': item?.listado_otro_texto ?? '',
                                                            'verificacion_lpo' : item?.verificacion_lpo ?? false,
                                                            'verificacion_opr' : item?.verificacion_opr ?? false,
                                                            'verificacion_cor' : item?.verificacion_cor ?? false,
                                                            'verificacion_ue' : item?.verificacion_ue ?? false,
                                                            'verificacion_nop' : item?.verificacion_nop ?? false,
                                                            'verificacion_no_permitido' : item?.verificacion_no_permitido ?? false,
                                                        }

                                                        try {
                                                            await this.substanceService.evaluationSubstances(substance).toPromise()
                                                        } catch (error) {
                                                            // console.log('Evaluation substances')
                                                            this.alertService.error(error)
                                                        }
                                                    }
                                                }

                                                try {
                                                    await this.requestsService.saveForm(this.recordId, this.formInspection, formGroup.value, this.inspectionId).toPromise()
                                                } catch (error) {
                                                    // console.log('save form')
                                                    this.alertService.error(error)
                                                }

                                                this.ncsService.substanceNcsReview(this.recordId, this.inspectionId, 0)
                                                    .subscribe(
                                                        data => {
                                                            modal.close(true)
                                                        },
                                                        error => {
                                                            this.saving = false
                                                            this.alertService.error(error, {
                                                                autoClose: true
                                                            })
                                                        }
                                                    )
                                            }
                                        }, error => {
                                            this.saving = false
                                            this.alertService.error(error, {
                                                autoClose: true
                                            })
                                        }
                                    )
                            } else {
                                if(this.saveAll) {
                                    this.alertService.warn('Asegúrate de haber completado todos los campos necesarios (Verificación de cada sustancia)', {
                                        autoClose: true
                                    })
                                }
                                else {
                                    this.alertService.warn('Asegúrate de haber completado todos los campos necesarios (Verificación de sustancia)', {
                                        autoClose: true
                                    })
                                }
    
                                this.closeModal = false
                                this.saveAll = false
                                this.saving = false
                                this.saveSubstance = false
                                this.substanceIndex = 0
                                
                                formGroup.enable()
                            }
                        }
                    }
                } else if (msg.identifier === 'send-form') {
                    const formGroup = msg.form as FormGroup
                    const f = formGroup.value
                    var data = f
                    for (var i in this.requirements) {
                        const requirement = this.requirements[i]
                        if (Object.keys(requirement.data).length > 0) {
                            if (requirement.isDynamic) {
                                const form = data[requirement.requiredInto][0]
                                let nval = []
                                for (var j in requirement.data) {
                                    const r = requirement.data[j]
                                    let s = {
                                        ...form
                                    }
                                    const q = f[requirement.requiredInto][j]
                                    if (!q) {
                                        Object.keys(r).forEach(key => {
                                            s[key] = r[key]
                                        })
                                        nval.push(s)
                                    } else {
                                        Object.keys(r).forEach(key => {
                                            if (r[key]) {
                                                q[key] = r[key]
                                            }
                                        })
                                        nval.push(q)
                                    }
                                }
                                data[requirement.requiredInto] = nval
                                //console.log(data[requirement.requiredInto])
                            } else {
                                data[requirement.requiredInto] = requirement.data
                            }
                        }
                    }

                    setTimeout(() => {
                        this.formCommunication.emitEvent({
                            identifier: 'set-values',
                            form: data
                        })
                    }, 100);
                } else if (msg.identifier === 'file') {
                    let added = false
                    for (var i in this.files) {
                        const file = this.files[i]
                        if (file.formname == msg.formname && file.atIndex == msg.atIndex) {
                            this.files[i] = msg
                            added = true
                            break
                        }
                    }
                    if (!added) {
                        this.files.push(msg)
                    }
                } else if (msg.identifier === 'uploading') {
                    this.percentage = msg.percentage
                } else if (msg.identifier === 'reload') {
                    this.saveSubstance = true
                    this.saveSubstanceOnly = true
                    this.saving = true
                    this.saveForm()
                } else if(msg.identifier === 'save-substance') {
                    this.substanceIndex = msg.substanceIndex
                    this.saveSubstance = true
                    this.saveSubstanceOnly = true
                    this.saving = true
                    this.saveForm()
                } else if(msg.identifier === 'update-substance-index') {
                    this.substanceIndex = msg.substanceIndex
                }
            }
        )
    }
    
    ngOnInit(): void {
        localStorage.setItem('currentRecordId', this.recordId)

        if(this.version === 1) {
            this.versionForm = 13
            this.formInspection = 30
        }
        if(this.version === 2) {
            this.versionForm = 213
            this.formInspection = 230
        }
        if(this.version === 3) {
            this.versionForm = 313
            this.formInspection = 330
        }
        if(this.version === 4) {
            this.versionForm = 413
            this.formInspection = 430
        }
        if(this.version === 5) {
            this.versionForm = 513
            this.formInspection = 530
        }

        this.getSubstances()
    }

    getSubstances() {
        this.substanceService.getDetailsSubstancesNonEvaluated(this.recordId, this.versionForm)
            .subscribe(
                data => {
                    this.currentForm = data.form
                    this.lastSubmission = data.submissions
                    this.requirements = data.requirements
                    this.code = data.idSolicitud

                    if(this.lastSubmission !== null) {
                        let lastForm = {}
                        for(let i in this.lastSubmission) {
                            const obj = this.lastSubmission[i]
                            lastForm[obj.name] = obj.value
                        }

                        setTimeout(() => {
                            this.formCommunication.emitEvent({
                                identifier: 'set-values',
                                form: lastForm
                            })
                        }, 100)
                        this.saved = true
                        this.requiredForm = lastForm
                    }

                    setTimeout(() => {
                        this.saving = false
                        this.formCommunication.emitEvent({
                            identifier: 'submit'
                        })
                        this.loading = false
                    }, 100);

                },
                error => {
                    this.alertService.error(error);
                    this.loading = false
                }
            )
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe()
    }

    reloadFormData(data) {
        this.lastSubmission = data.submission

        if (this.lastSubmission !== null) {
            let lastForm = {}
            for (var i in this.lastSubmission) {
                const obj = this.lastSubmission[i]                
                lastForm[obj.name] = obj.value
            }

            setTimeout(() => {
                this.formCommunication.emitEvent({
                    identifier: 'set-values',
                    form: lastForm
                })
            }, 100)

            this.saved = true
            this.requiredForm = lastForm
        }
        this.saveSubstanceOnly = false

        setTimeout(() => {
            this.formCommunication.emitEvent({
                identifier: 'submit'
            })

            this.save = false
            this.loading = false
        }, 100)
    }

    onlySave() {
        this.closeModal = true
        this.saveOnly = true
        this.saveForm()
    }

    goBack() {
        this.closeModal = true
        this.saveAll = true
        this.saveForm()
    }

    saveForm() {
        this.saving = true
        this.formCommunication.emitEvent({
            identifier: 'submit'
        })
    }
}